import { render, staticRenderFns } from "./record-video.vue?vue&type=template&id=50f1f85a&scoped=true"
import script from "./record-video.vue?vue&type=script&lang=js"
export * from "./record-video.vue?vue&type=script&lang=js"
import style0 from "./record-video.vue?vue&type=style&index=0&id=50f1f85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f1f85a",
  null
  
)

export default component.exports